/* eslint-disable react/prop-types */

import React  from 'react';
import PropTypes from 'prop-types';

import { Button } from 'react-bootstrap';

import { UISettings } from '../contexts/UISettings';

import { TaskStore } from '../store/TaskStore';

import { TaskDataGrid } from './tasks/TaskDataGrid';
import { TaskEdit } from './tasks/TaskEdit';

import { Nav } from './Nav';
import { Toolbar } from './Toolbar';

const TasksInner = ({api, onError }) => {
    //const authStore = useAuth();
    const [showPage, setShowPage] = React.useState('list');

    const createTaskStore = () => {
        const ts = new TaskStore(api);

        ts.load().catch(err => onError(err.toString()));

        return ts;
    };

    const [taskStore] = React.useState(() => createTaskStore());

    return (
        <div>
            <Nav />

            <Toolbar api={api} dateDisabled={true} >
                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                    {
                        showPage === 'list'
                        ? <Button variant='info' onClick={() => setShowPage('addTask')} className='ms-2'>
                            Create Task
                        </Button>
                        : null
                    }
                </div>
            </Toolbar>

            {
                showPage === 'addTask'
                ? <TaskEdit
                    api={api}
                    taskStore={taskStore}
                    onError={onError}
                    onClose={() => setShowPage('list')}
                />
                : null
            }

            <TaskDataGrid
                api={api}
                onError={onError}
                taskStore={taskStore}
                style={showPage === 'list' ? undefined : { display: 'none' }}
            />
        </div>
    );
};

const Tasks = props => {
    return <UISettings.Consumer>{
        ({ pushError }) => <TasksInner {...props} onError={pushError} />
    }</UISettings.Consumer>;
}

Tasks.propTypes = {
    api: PropTypes.object.isRequired,
};

export {
    Tasks,
}
